import type { EmployeeAlertResignationDateBeforeLastWorkingDate } from '@/common/graphql';

import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertResignationDateBeforeLastWorkingDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertResignationDateBeforeLastWorkingDate, 'lastWorkingDate' | 'resignationDate'>;
}) => (
  <>
    <div>
      <FormattedDate prefix="Last working date" date={reason.lastWorkingDate} />
    </div>
    <div>
      <FormattedDate prefix="Employment end date" date={reason.resignationDate} />
    </div>
  </>
);
